import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingofMenus = () => {

    const servicesFaqData = [
        {
            question: "What customisation options are available for menu printing?",
            answer: "Printingy offers extensive customisation for the Printing of Menus, including custom sizes, paper types, finishes, and fold styles. Our design menu printing services allow you to incorporate logos, branding elements, and creative layouts to suit your establishment’s needs."
        },
        {
            question: "Does Printingy handle bulk orders for menu printing?",
            answer: "Yes, Printingy specialises in bulk menu printing, offering cost-effective solutions for restaurants, cafes, hotels, and catering businesses. Bulk orders ensure consistent quality and competitive pricing for large-scale printing needs."
        },
        {
            question: "What types of finishes are available for custom menu cards?",
            answer: "We provide a variety of finishes for custom menu card printing, including matte, glossy, laminated, and waterproof options. These finishes enhance durability and visual appeal, ensuring menus remain professional and long-lasting even with frequent use."
        },
        {
            question: "What industries benefit from custom menu printing services?",
            answer: "Our restaurant's menu printing services cater to the hospitality industry, including restaurants, cafes, hotels, catering companies, and event organisers. Businesses rely on the Printing of Menus to showcase offerings in an organised and visually appealing manner."
        },
        {
            question: "Can I include a unique design or theme on my menus?",
            answer: "Absolutely. Our design menu printing services allow complete customisation, including themed designs, branded layouts, and unique visuals. Whether for daily menus or special events, we help you create menus that reflect your brand’s personality and style."
        },
        {
            question: "What is the turnaround time for bulk menu printing?",
            answer: "The turnaround time for menu printing depends on the order size and complexity. Standard bulk orders are completed within a few business days. We provide clear timelines for larger volumes or specialised designs to meet your deadlines."
        },
        {
            question: "Do you offer waterproof and tear-resistant menu printing?",
            answer: "Yes, we offer waterproof and tear-resistant options for restaurant menu printing, making them ideal for high-traffic environments like restaurants, cafes, and bars. These menus are durable, easy to clean, and maintain quality over time."
        },
        {
            question: "How can I place an order for custom menu card printing?",
            answer: "Placing an order is easy. Visit our website and select your preferences for custom menu card printing, including sizes, finishes, and designs. Upload your artwork or share your requirements, and our team will assist you from approval to delivery."
        },
        {
            question: "What factors should I consider when designing menus?",
            answer: "When creating designs for menu printing, consider your audience, branding style, and menu layout. Clear organisation, attractive visuals, and durable materials ensure an engaging and professional experience for your customers."
        },
        {
            question: "Why is bulk menu printing cost-effective for restaurants?",
            answer: "Bulk Printing of Menus reduces per-unit costs, making it economical for restaurants and hospitality businesses. By streamlining production and materials, Printingy ensures competitive pricing while maintaining the professional quality and timely delivery."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Menus');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Menu Printing Services for Restaurants and Businesses"
  description="Professional printing of menus for restaurants and businesses. Bulk menu printing, custom menu card printing, and design menu printing for branding."
  keywords="Printing of Menus,
Custom Menu Cards Printing,
Menus Printing,
Design Menus Printing,
Restaurants Menus Printing

"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Menus</h1>
              <h2 className="text-muted">
              Custom menu cards and restaurant menus with vibrant designs
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Menus are essential for restaurants, cafes, and events, serving as the primary medium for showcasing offerings and enhancing the dining experience. Printingy specialises in the Printing of Menus, offering custom menu card printing and menu printing services tailored to your brand’s identity.</p>
          <p>Our solutions include designing menus printed with vibrant colours, sharp graphics, and durable finishes. From stylish restaurant menus for fine dining establishments to sleek, practical designs for casual eateries and cafes, we provide bulk printing services that combine functionality and elegance.</p>
          <p>Whether for daily menus, event-specific specials, or takeaway lists, Printingy guarantees professional results with precise printing and customisation that aligns with your vision.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Menu Printing Solutions </h2>
                <h3 className="large-hed">High-quality, durable, and stylish menu cards for restaurants and events</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Menus for restaurants, cafes, and events.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk custom menu card printing for cost-effective solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional design menu printing with sharp visuals and vibrant colours.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials, including waterproof and tear-resistant finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Custom sizes, styles, and folds tailored to your needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for consistent quality and precision.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk orders and urgent requests.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for restaurants, hotels, catering businesses, and events.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/menuprinting.jpg" // Path relative to the public folder
                  alt="High-quality custom menu card printing"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Menus Delivered On Time</h2>
            <h3 className="small-hed">Focus on your offerings while we handle your menu printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with premium materials to deliver exceptional restaurant menu printing services. Whether you need bulk custom menu card printing for an upscale restaurant or simple designs for cafes and events, we ensure precision, quality, and consistency.</p>
            <p>Our streamlined production processes guarantee quick turnarounds and reliable delivery, ensuring your menu printing is ready when needed. Partner with Printingy to enhance your dining experience with high-quality menu printing solutions.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingofMenus;
